import Skeleton from '@creditflowresearch/uilib/Skeleton';
import { IColumn } from '../interfaces';
import styles from './skeletonRows.module.scss';

interface IProps {
  columns: IColumn[],
  rowCount: number,
  maxColumnsCount: number,
}

const SkeletonRows = ({ columns, rowCount, maxColumnsCount }: IProps) => {
  const visibleColumns = columns
    .filter((col) => col.isVisible || col.isVisible === undefined)
    .slice(0, maxColumnsCount);

  return (
    <tbody data-test="loader">
      { Array.from({ length: rowCount }, (_, rowIndex) => (
        <tr key={ rowIndex } className={ styles.skeletonRow }>
          { visibleColumns.map((col) => (
            <td
              key={ col.name }
              style={ col.width ? { width: col.width } : undefined }
            >
              <Skeleton />
            </td>
          )) }
        </tr>
      )) }
    </tbody>
  );
};

export default SkeletonRows;
